<template>
  <!-- 添加或修改设备调换记录对话框 -->
  <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="类型" prop="type">
        <el-input v-model="form.type" placeholder="请输入类型" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {imageTypeAdd, imageTypeUpd} from "@/api/imageType";
export default {
  components: {},
  data() {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      },
      orderList: [],
      btnShow: false,
      DeviceInfoList: []
    }
  },
  methods: {
    addCreateForm(platForm) {
      this.reset()
      this.open = true
      this.title = '添加类型'
      this.btnShow = true
      this.form.platForm = platForm
    },
    showCreateForm(record) {
      this.reset()
      this.open = true
      this.form = record
      this.title = '修改类型'
      this.btnShow = false
    },
        // 表单重置
    reset() {
      this.form = {
        id: null,
        platForm: null,
        type: null
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            imageTypeUpd(this.form).then(response => {
              this.$modal.msgSuccess("修改成功")
              this.open = false
              this.$emit('ok')
            })
          } else {
            imageTypeAdd(this.form).then(response => {
              this.$modal.msgSuccess("新增成功")
              this.open = false
              this.$emit('ok')
            })
          }
        }
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.$emit('ok')
    }
  },
  mounted() {
  }
}
</script>

<style></style>
